import { configuration as configurationRoute } from '../../../data/enums/Route';
import { FILTER } from '../../../data/enums/filter';
import { getFilterConfig } from '../../../utils/filter';

const breadCrumb = [
  configurationRoute,
];
const filter = getFilterConfig([FILTER.DSE]);
export { breadCrumb, filter as filterConfig };
